<template>
  <modal
    :show="true"
    :large="true"
    v-on:close="closeOccupantModal"
    :enable-event="!alertIsOpen"
  >
    <h4 slot="title">Edit Occupant</h4>
    <div class="row">
      <fieldset
        :disabled="readonly"
        style="border:0;padding:0;margin:0;min-width:0;"
      >
        <div class="col-xl-12">
          <div class="form-horizontal">
            <selectlist
              :options="types"
              v-model="form.type_id"
              label="Occupant Type"
              name="type"
              placeholder="Please Select"
              :readonly="readonly"
            ></selectlist>

            <inputbox
              v-model="form.first_name"
              name="first_name"
              label="First Name"
              :readonly="readonly"
            ></inputbox>

            <inputbox
              v-model="form.last_name"
              name="last_name"
              label="Last Name"
              :readonly="readonly"
            ></inputbox>

            <date-of-birth
              :required="true"
              v-model="form.date_of_birth"
              :unlimited="true"
              :readonly="readonly"
            ></date-of-birth>

            <inputbox
              v-model="form.occupation"
              name="occupation"
              label="Occupation"
              :readonly="readonly"
            ></inputbox>

            <inputbox
              v-model="form.medical_conditions"
              name="medical_conditions"
              label="Medical Conditions"
              :readonly="readonly"
            ></inputbox>

            <inputbox
              v-model="form.relation_to_client"
              name="relation_to_client"
              label="Relation to Client"
              :readonly="readonly"
            ></inputbox>

            <inputbox
              v-model="form.national_insurance"
              name="national_insurance_number"
              label="National Insurance Number"
              :readonly="readonly"
            ></inputbox>

            <selectlist
              :options="positions"
              v-model="form.position_id"
              label="Seat/Position"
              name="position"
              placeholder="Please Select"
              :readonly="readonly"
            ></selectlist>

            <toggleswitch
              :labels="true"
              name="requires_glasses"
              label="Requires Glasses?"
              v-model="form.requires_glasses"
              :disabled="readonly"
            ></toggleswitch>

            <toggleswitch
              :labels="true"
              name="wearing_seatbelt"
              label="Wearing Seatbelt?"
              v-model="form.wearing_seatbelt"
              :disabled="readonly"
            ></toggleswitch>

            <fieldset>
              <legend>
                Contact Details
                <small class="text-muted"
                  >- Enter the occupants contact details here</small
                >
              </legend>

              <inputbox
                v-model="form.telephone"
                name="telephone"
                label="Telephone"
                :readonly="readonly"
              ></inputbox>

              <inputbox
                v-model="form.email_address"
                name="email"
                label="Email Address"
                type="email"
                :readonly="readonly"
              ></inputbox>
            </fieldset>
            <fieldset>
              <legend>
                Address Details
                <small class="text-muted"
                  >- Enter the occupants address details here</small
                >
              </legend>
              <address-lookup
                :address="address"
                v-on:address="setAddress"
                :readonly="readonly"
              ></address-lookup>
            </fieldset>

            <fieldset>
              <legend>
                Injury Details
                <small class="text-muted"
                  >- Enter the occupants injury details here</small
                >
              </legend>

              <input-block
                v-model="form.injury_details"
                name="injury_details"
                label="Injury Details"
                helper="Please enter a description of the occupant's injury"
                :readonly="readonly"
              ></input-block>

              <toggleswitch
                :labels="true"
                name="has_representation"
                label="Has Representation?"
                helper="Does the occupany have representation already?"
                v-model="form.has_representation"
                :disabled="readonly"
              ></toggleswitch>

              <div v-if="form.has_representation">
                <inputbox
                  v-model="form.representation_company_name"
                  name="representation_company_name"
                  label="Company Name"
                  helper="Please enter the name of the company representing the occupant"
                  :readonly="readonly"
                ></inputbox>

                <inputbox
                  v-model="form.representation_reference"
                  name="representation_reference"
                  label="Reference"
                  helper="Please enter the reference for the occupants injury"
                  :readonly="readonly"
                ></inputbox>

                <inputbox
                  v-model="form.representation_email"
                  name="representation_email"
                  label="Email"
                  helper="Please enter an email address for the company representing the occupant"
                  :readonly="readonly"
                ></inputbox>

                <inputbox
                  v-model="form.representation_telephone"
                  name="representation_telephone"
                  label="Telephone"
                  helper="Please enter a telephone number for the company representing the occupant"
                  :readonly="readonly"
                ></inputbox>
              </div>
            </fieldset>
          </div>
        </div>
      </fieldset>
    </div>
    <div slot="footer">
      <div class="float-left">
        <form-button
          v-if="!readonly"
          :indicator="indicator"
          v-on:clicked="deleteOccupant"
          level="danger"
          >Delete</form-button
        >
      </div>
      <button
        type="button"
        v-on:click="closeOccupantModal"
        class="btn btn-danger"
      >
        Close
      </button>
      <form-button
        v-if="!readonly"
        :indicator="form.processing()"
        v-on:clicked="updateOccupant"
        >Update Occupant</form-button
      >
    </div>
  </modal>
</template>
<script>
import { readonly } from 'vue';

export default {
  props: {
    incident: {
      type: String,
      required: true
    },

    types: {
      type: Array,
      required: true
    },

    positions: {
      type: Array,
      required: true
    },

    occupant: {
      type: Object,
      required: true
    },

    readonly: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      alertIsOpen: false,
      form: new window.Form({
        type_id: this.occupant.type_id,
        first_name: this.occupant.first_name,
        last_name: this.occupant.last_name,
        date_of_birth: this.occupant.date_of_birth
          ? this.occupant.date_of_birth
          : null,
        occupation: this.occupant.occupation,
        medical_conditions: this.occupant.medical_conditions,
        relation_to_client: this.occupant.relation_to_client,
        national_insurance: this.occupant.national_insurance,
        position_id: this.occupant.position_id,
        requires_glasses: this.occupant.requires_glasses,
        wearing_seatbelt: this.occupant.wearing_seatbelt,
        telephone: this.occupant.telephone,
        email_address: this.occupant.email_address,
        address_line_one: this.occupant.address_line_one,
        address_line_two: this.occupant.address_line_two,
        city: this.occupant.city,
        postcode: this.occupant.postcode,
        injury_details: this.occupant.injury_details,
        has_representation: this.occupant.has_representation,
        representation_company_name: this.occupant.representation_company_name,
        representation_reference: this.occupant.representation_reference,
        representation_email: this.occupant.representation_email,
        representation_telephone: this.occupant.representation_telephone
      }),
      indicator: false
    };
  },

  computed: {
    address() {
      return {
        address_line_one: this.form.address_line_one,
        address_line_two: this.form.address_line_two,
        city: this.form.city,
        postcode: this.form.postcode
      };
    }
  },

  methods: {
    setAddress(address) {
      this.form.address_line_one = address.address_line_one;
      this.form.address_line_two = address.address_line_two;
      this.form.city = address.city;
      this.form.postcode = address.postcode;
    },

    deleteOccupant() {
      this.alertIsOpen = true;

      window
        .swal({
          title: 'Are you sure?',
          text: 'You cannot undo this',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes'
        })
        .then(confirmed => {
          if (confirmed) {
            this.indicator = true;
            window.Ajax.delete(
              '/incidents/' +
                this.incident +
                '/occupants/' +
                this.occupant.identifier
            )
              .then(response => {
                this.$emit('deleted', this.occupant);
                this.indicator = false;
              })
              .catch(error => {
                this.indicator = false;
                window.toastify.error(
                  'Error',
                  'Sorry, there was an error deleting the occupant.'
                );
              });
          }
        })
        .catch(error => {
          setTimeout(() => {
            this.alertIsOpen = false;
          }, 500);
        });
    },

    closeOccupantModal() {
      if (this.readonly) {
        this.$emit('close');
        return;
      }

      this.alertIsOpen = true;

      window
        .swal({
          title: 'Are you sure?',
          text: 'You will lose any unsaved changes',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes'
        })
        .then(confirmed => {
          if (confirmed) {
            this.$emit('close');
          }
        })
        .catch(error => {
          setTimeout(() => {
            this.alertIsOpen = false;
          }, 500);
        });
    },

    updateOccupant() {
      this.form
        .put(
          '/incidents/' +
            this.incident +
            '/occupants/' +
            this.occupant.identifier
        )
        .then(response => {
          this.$emit('updated', response);
        })
        .catch(response => {
          window.toastify.error(
            'Error',
            'Sorry, there was an error updating the incident'
          );
        });
    }
  }
};
</script>
